import {pageInfo, getBindPlantStorage, addPlantArea, preview, updatePlantArea, uploadUrl, updatePlantAreaDetail} from './../api';
import {Message} from 'element-ui';
import {plant, getPlantGateSentry} from "../../../../api";

const plantArea = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    plantObj: [],
    plantAreaObj: [],
    exportObj: [],
    plantStorageResp :null,
    addPlantAreaObj: null,
    updatePlantAreaObj: null,
    updatePlantAreaDetailObj: null,
    uploadUrl,
    plantGateSentryObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({...item, btns: [true]}));
    },
    PLANT(state, data) {
      state.plantObj = data;
    },
    GET_BIND_PLANT_STORAGE(state,data){
      state.plantStorageResp = (data.obj || []).map(item => ({...item, btns: [true]}));
    },
    ADD_PLANT_AREA(state,data){
      state.addPlantAreaObj = data;
    },
    UPDATE_PLANT_AREA(state,data){
      state.updatePlantAreaObj = data;
    },
    UPDATE_PLANT_AREA_DETAIL(state,data){
      state.updatePlantAreaDetailObj = data;
    },
    PLANT_GATE_SENTRY(state, data){
      state.plantGateSentryObj = data.obj;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
    async getBindPlantStorage({commit}, obj){
      let resp = await getBindPlantStorage(obj);
      commit('GET_BIND_PLANT_STORAGE', resp);
    },
    async addPlantArea({commit}, obj){
      let resp = await addPlantArea(obj);
      commit('ADD_PLANT_AREA', resp);
    },
    async updatePlantArea({commit}, obj){
      let resp = await updatePlantArea(obj);
      commit('UPDATE_PLANT_AREA', resp);
    },
    //修改初始化
    async updatePlantAreaDetail({commit}, obj){
      let resp = await updatePlantAreaDetail(obj);
      commit('UPDATE_PLANT_AREA_DETAIL', resp);
    },
    //门岗下拉框
    async getPlantGateSentry({ commit }, obj) {
      let resp = await getPlantGateSentry(obj);
      commit('PLANT_GATE_SENTRY', resp);
    },
  }
}
export default plantArea



// WEBPACK FOOTER //
// ./src/page/md/plantArea/store/plantArea.store.js